import React from 'react'
import { SVGIcon } from '~/utils/types'


export const LaboPipe = (props: SVGIcon) => (
  <svg
    {...props}
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.87459484,23.4136415 L9.87459484,27 L17.1261875,27 L17.1261875,22.9685742 L15.0262658,22.9685742 L15.0262658,10.0314258 L17.1261875,10.0314258 L17.1261875,6 L9.87459484,6 L9.87459484,23.7753407 M32,9.18439753 L22.8132335,9.19118076 L22.8130099,11.5626849 L19.0658321,11.5626849 C19.0658321,11.5626849 19.0931038,21.3990226 19.0658321,21.3990226 L22.8130099,21.3990226 L22.8130099,23.7733714 L32,23.7731526 M0.00290600201,23.3451528 L9.87459484,23.3451528 M9.87459484,9.65506606 L0,9.65506606"
      id="Stroke-1"
      stroke="#FFF"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
)
